/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyWheelItem.vue?vue&type=template&id=ac3d93b4"
import script from "./luckyWheelItem.vue?vue&type=script&lang=js"
export * from "./luckyWheelItem.vue?vue&type=script&lang=js"
import style0 from "./luckyWheelItem.vue?vue&type=style&index=0&id=ac3d93b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports